class ScrollingTicker extends HTMLElement {
  constructor() {
    super();
    this.tickerTrack = this.querySelector('.scrolling-ticker__track');
    this.tickerContent = this.querySelector('.scrolling-ticker__content');
    this.pauseOnHover = this.getAttribute('data-pause-on-hover') === 'true';
    
    if (!this.tickerContent) return;
    
    // Clone the content to create the continuous effect
    this.setupTicker();
    
    // Update the animation on window resize
    window.addEventListener('resize', this.debounce(this.setupTicker.bind(this), 250));
  }
  
  setupTicker() {
    const speed = parseInt(this.getAttribute('data-speed')) || 15;
    
    // Make sure content is wide enough to create a continuous scroll effect
    this.ensureContentWidth();
    
    // Calculate appropriate duration based on content width
    const contentWidth = this.tickerContent.scrollWidth / 2;
    
    // New improved formula for more balanced speed distribution:
    // - Speed 1 is very slow (300s for full scroll)
    // - Speed 50 is what 100 was before
    // - Speed 100 is twice as fast as before
    
    let duration;
    if (speed <= 1) {
      duration = 150; // Faster base speed (was 300)
    } else if (speed <= 50) {
      // Map 1-50 to faster speeds (150s down to 15s)
      duration = 150 - ((speed - 1) * (135 / 49));
    } else {
      // Map 51-100 to faster speeds (15s down to 2s)
      duration = 15 - ((speed - 50) * (13 / 50));
    }
    // Apply content width adjustment (longer content = longer duration)
    duration = duration * (contentWidth / 1000);
    
    // Set the duration through CSS variable
    this.tickerTrack.style.setProperty('--ticker-duration', `${duration}s`);
  }
  
  ensureContentWidth() {
    // Clear previous content if any
    if (this.contentCloned) {
      // Store the original content before clearing
      const originalItems = Array.from(this.tickerContent.querySelectorAll('.original-item'));
      this.tickerContent.innerHTML = '';
      
      // Re-add the original items first
      originalItems.forEach(item => {
        this.tickerContent.appendChild(item.cloneNode(true));
      });
    } else {
      // First time setup - mark original items
      Array.from(this.tickerContent.children).forEach(item => {
        item.classList.add('original-item');
      });
    }
    
    // Get all original items
    const originalContent = Array.from(this.tickerContent.querySelectorAll('.original-item'));
    const tickerWidth = this.tickerTrack.offsetWidth;
    
    // Create multiple copies to ensure no visible gaps
    // We need at least 2 full loops to ensure smooth infinite scrolling
    const numCopies = Math.max(4, Math.ceil((tickerWidth * 3) / this.tickerContent.scrollWidth));
    
    for (let i = 0; i < numCopies; i++) {
      originalContent.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.remove('original-item'); // Only originals keep the class
        this.tickerContent.appendChild(clone);
      });
    }
    
    this.contentCloned = true;
  }
  
  // Simple debounce function to limit resize events
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('scrolling-ticker', ScrollingTicker);